import styled from "styled-components";
import { colorPalette, typeScale } from "../../utils/theme";

export const StyledSection = styled.section<{ withoutBackground?: boolean }>`
  padding: 60px 70px;
  padding-bottom: calc(60px + var(--safe-area-inset-bottom));
  text-align: center;
  background: ${props => props.withoutBackground ? "transparent" : colorPalette.blue50};
  
  @media (max-width: 767.98px) {
    padding: 64px 16px;
    padding-bottom: calc(64px + var(--safe-area-inset-bottom));
  }
`;

export const PackageSectionHeadline = styled.h4`
  margin-bottom: 8px;
  color: ${colorPalette.textMain};
  ${typeScale.headingMain};

  @media (max-width: 767.98px) {
    text-align: start;
  }
`;

export const PackageSectionDescription = styled.p`
  margin-bottom: 32px;
  color: ${colorPalette.textDark};
  ${typeScale.bodyMD};

  @media (max-width: 767.98px) {
    text-align: start;
    ${typeScale.bodySM};
  }
`;

export const HorizontalScrollWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  padding-left: 16px;
  padding-right: 16px;
  margin-left: -16px;
  margin-right: -16px;

  &::-webkit-scrollbar {
    display: none;
  }

  > * {
    flex: 0 0 calc(98%);
    scroll-snap-align: start;
  }
`;

export const PackageButtonWrapper = styled.div`
  margin-top: 32px;
  justify-self: center;
  width: 100%;

  @media (max-width: 767.98px) {
    margin-top: 24px;
    width: 100%;
  }
`;
